import moment from 'moment';
import _ from 'lodash';

export function createReportName(record) {
    let tableName = _.get(record, 'queryStringParameters.table');
    const exportRangeStart = moment.utc(_.get(record, 'queryStringParameters.startDate')).format('DD MMM YYYY');
    const exportRangeEnd = moment.utc(_.get(record, 'queryStringParameters.endDate')).format('DD MMM YYYY');

    switch (tableName) {
        case 'transaction':
            tableName = 'Transactions';
            break;
        case 'chargeback':
            tableName = 'Chargebacks';
            break;
        case 'depositsummary':
            tableName = 'Deposit Summary';
            break;
        case 'adjustment':
            tableName = 'Adjustments';
            break;
        case 'batchdetails':
            tableName = 'Batch Details';
            break;
        case 'statement':
            tableName = 'Statements';
            break;
        case 'fraud':
            tableName = 'Fraud';
            break;
        case 'reserve':
            tableName = 'Reserves';
            break;
        default:
        //  do nothing
    }

    return `${tableName} - ${exportRangeStart} - ${exportRangeEnd}`;
}

export function determineStatus(report) {
    const aggregated = _.get(report, 'aggregated');
    const failed = _.get(report, 'failed');
    if (failed) {
        return 'Failed';
    } else if (aggregated) {
        return 'Ready';
    }

    return 'Pending';
}
